import { SET_ACCOUNT_NAME } from '../actions/account';

const initialState = {
  accountName: ''
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACCOUNT_NAME:
      return {
        ...state,
        accountName: action.payload.accountName,
        companyName: action.payload.companyName,
        companyRUT: action.payload.companyRUT,
        country: action.payload.country,
        twistgo: action.payload.twistgo,
        firstname: action.payload.firstname,
        lastname: action.payload.lastname,
        email: action.payload.email,
        phone: action.payload.phone,
        serviceTier: action.payload.serviceTier
      };
    default:
      return state;
  }
};

export default accountReducer;
